import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AuthService } from '../../services/components/auth.servicice';
import { Router } from '@angular/router';
import { Sit2Service } from '../../services/http/sit2.service';
import { DatatableComponent } from './../../shared/components/data-table/datatable.component';
import { ModalService } from '../../shared/services/modal.service';

declare let gtag: Function;

@Component({
  selector: 'app-obligaciones-pendientes',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './obligaciones_pendientes.component.html',
  styleUrl: './obligaciones_pendientes.component.scss'
})

export class ObligacionesPendientesComponent extends DatatableComponent implements OnInit {

  showViewHTMLComponent = false;
  listActividades = [];

  override originalData: any[] = [];

  constructor(private router: Router,
    private sit2Service: Sit2Service,
    private modalService:ModalService,
    private authService: AuthService) {
    super()
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/login']);
      return;
    } else {

    }
    const config = this.authService.getValueConfig();
    
  }

  ngOnInit() {
    try {
      window.scrollTo(0, 0);
    } catch (error) {
      console.error(error);
    }
    this.obtenerActividades();
    this.applyFilter();

    if (typeof gtag === 'function') {
      try {
        gtag('event', 'page_view', { page_path: '/OficinaVirtualSIT2/industria_y_comercio/obligaciones_pendientes' });
      } catch (err) {}
    }
  }

  obtenerActividades() {
    this.originalData = [];
    this.sit2Service.getMisAct().subscribe({
      next: (response) => {
        if (!(response === void 0)) {
          if (response.codigoError == 0) {
            for (let x = 0; x < response.estadosc.length; x++) {
              response.estadosc[x].$$key_data_id = x;
              response.estadosc[x].$$isMenuOpen = false;
              response.estadosc[x].btnFormulario = false;
              response.estadosc[x].btnPagar = false;
              response.estadosc[x].btnLiquidar = true;

              if (response.estadosc[x].idSoporte > 0) {
                response.estadosc[x].btnFormulario = true;
                response.estadosc[x].btnPagar = true;
                response.estadosc[x].btnLiquidar = false;
              }
            }
            this.originalData = this.verificaArray(response.estadosc);
            this.applyFilter()
            this.showViewHTMLComponent = true;
          }
        } else {
          this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "Servicio no disponible, por favor intente más tarde");
        }
      },
      error: (err) => {
        this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "Error consultando la información del servidor");
      }
    });
  }

  getFormulario(obj: any) {
    const idSoporte = obj.idSoporte;
    const config = this.authService.getValueConfig();
    this.sit2Service.cifrarIdXBarcode(idSoporte).subscribe({
      next: (response) => {
        if (!(response === void 0)) {
          window.open(config.urlFormulario + response.valor);
        } else {
          this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "Servicio no disponible, por favor intente más tarde");
        }
      },
      error: (err) => {
        this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "Error consultando la información del servidor");
      }
    });
  };

  getPagar(obj: any) {
    this.toggleMenuAll();
    const config = this.authService.getValueConfig();
    //console.log( "En getPagar: " + obj.saldoImpuesto + "-" + obj.idSoporte + ":)" ) ;
    let url = config.urlPagoTraps + "?idSoporte=" + obj.idSoporte;
    window.open(url);
  };

  getLiquidar(obj: any) {
    //console.log( "En getLiquidar: " + obj.saldoImpuesto + "-" + obj.idSoporte + ":)" ) ;
    const config = this.authService.getValueConfig();
    let res = config.urlLiquidadorIca;
    window.open(res);
  }

  override applyFilter(): void {
    const searchTerm = this.filterTerm.toLowerCase();

    this.currentData = this.originalData.filter(item =>
      String(item.vigencia).toLowerCase().includes(searchTerm) ||
      String(item.periodo).toLowerCase().includes(searchTerm) ||
      String(item.estado).toLowerCase().includes(searchTerm) ||
      String(item.saldoImpuesto).toLowerCase().includes(searchTerm) ||
      String(item.interes).toLowerCase().includes(searchTerm) ||
      String(item.sancion).toLowerCase().includes(searchTerm)
    );

    this.currentPage = 1;
  }

  

  @HostListener('document:click', ['$event.target'])
  onClick(targetElement: any): void {
    // Si el clic no fue dentro de un dropdown, cierra todos los menús
    const clickedInsideDropdown = targetElement.closest('.dropdown');
    if (!clickedInsideDropdown) {
      if(this.controlCloseAllMenus){
        let temp = [...this.currentData].map((item_local) => {
          return {
            ...item_local,
            $$isMenuOpen: false
          };
        });
        this.currentData = temp;
        this.controlCloseAllMenus = false;
      }
    }

  }

}
